/**
 * GTM purchase bridge: writes checkout_data + customer_info before thank-you redirect.
 * Used by cart checkout and popup checkout on successful create_order.php response.
 */
(function (global) {
  'use strict';

  var CURRENCY = 'MAD';
  var CATEGORY = 'Clothing';

  function storageSet(key, value) {
    try {
      global.localStorage.setItem(key, value);
      return true;
    } catch (e) {
      return false;
    }
  }

  function normalizeCustomer(customer) {
    customer = customer || {};
    return {
      name: String(customer.name || '').trim(),
      phone: String(customer.phone || '').trim(),
      city: String(customer.city || '').trim(),
      address: String(customer.address || '').trim()
    };
  }

  function normalizeItems(items) {
    if (!items || !items.length) return [];
    return items.map(function (item) {
      return {
        item_id: String(item.item_id != null ? item.item_id : ''),
        item_name: String(item.item_name || 'منتج'),
        item_category: item.item_category || CATEGORY,
        price: Number(item.price) || 0,
        quantity: Number(item.quantity) || 1
      };
    });
  }

  function computeTotal(subtotal, shippingFees, coupon) {
    var finalPrice = Number(subtotal) || 0;
    if (coupon && coupon.discount_percent) {
      finalPrice -= Math.floor((finalPrice * coupon.discount_percent) / 100);
    }
    return Math.round(finalPrice + (Number(shippingFees) || 0));
  }

  function saveCustomerInfo(customer) {
    return storageSet('customer_info', JSON.stringify(normalizeCustomer(customer)));
  }

  function saveCheckoutData(payload) {
    var checkout = {
      currency: payload.currency || CURRENCY,
      value: Number(payload.value) || 0,
      items: normalizeItems(payload.items)
    };
    var ok = storageSet('checkout_data', JSON.stringify(checkout));
    if (payload.orderId != null && payload.orderId !== '') {
      storageSet('bambe_transaction_id', String(payload.orderId));
    }
    return ok;
  }

  /**
   * Call on order API success, before redirect to thank-you.
   */
  function saveForPurchase(opts) {
    opts = opts || {};
    saveCustomerInfo(opts.customer);
    return saveCheckoutData(opts);
  }

  /**
   * Popup: set customer_info from pc-* fields before GTM lead click handler runs.
   */
  function preparePopupLead() {
    var nameEl = global.document.getElementById('pc-name');
    var phoneEl = global.document.getElementById('pc-phone');
    var cityEl = global.document.getElementById('pc-city');
    var addressEl = global.document.getElementById('pc-address');
    return saveCustomerInfo({
      name: nameEl ? nameEl.value : '',
      phone: phoneEl ? phoneEl.value : '',
      city: cityEl ? cityEl.value : '',
      address: addressEl ? addressEl.value : ''
    });
  }

  /**
   * Build GTM items + total from Shopify cart.js line items (cart checkout).
   */
  function fromCartSuccess(cartItems, subtotal, shippingFees, coupon, customer, orderId) {
    var items = (cartItems || []).map(function (item) {
      var unit = Math.round(
        (item.final_price != null ? item.final_price : item.price) / 100
      );
      return {
        item_id: item.variant_id,
        item_name: item.product_title || 'منتج',
        item_category: CATEGORY,
        price: unit,
        quantity: item.quantity
      };
    });
    return saveForPurchase({
      currency: CURRENCY,
      value: computeTotal(subtotal, shippingFees, coupon),
      items: items,
      customer: customer,
      orderId: orderId
    });
  }

  /**
   * Build GTM payload from popup checkout totals.
   */
  function fromPopupSuccess(nums, variantId, productTitle, customer, orderId) {
    var qty = nums.billingQty != null ? nums.billingQty : nums.qty;
    var unitPrice = Math.round(
      nums.unitPrice != null ? nums.unitPrice : nums.price / (qty || 1)
    );
    return saveForPurchase({
      currency: CURRENCY,
      value: nums.total != null ? nums.total : computeTotal(nums.price, nums.shipping, null),
      items: [
        {
          item_id: variantId,
          item_name: productTitle,
          item_category: CATEGORY,
          price: unitPrice,
          quantity: qty
        }
      ],
      customer: customer,
      orderId: orderId
    });
  }

  global.BambeGtmBridge = {
    saveForPurchase: saveForPurchase,
    preparePopupLead: preparePopupLead,
    fromCartSuccess: fromCartSuccess,
    fromPopupSuccess: fromPopupSuccess,
    computeTotal: computeTotal
  };
})(typeof window !== 'undefined' ? window : this);
